import { combineReducers } from 'redux';
import getApiReducer from '../../../common/utils/getApiReducer';

import { GET_LIBRARY } from './actions';

import { FAVORITE_LIBRARY_VIDEO, UNFAVORITE_LIBRARY_VIDEO } from '../favorites/redux/actions';

const categoriesApiReducer = getApiReducer(GET_LIBRARY);
const categories = (state, action) => {
  let nextState = categoriesApiReducer(state, action);

  if (action.type === `${FAVORITE_LIBRARY_VIDEO}_SUCCESS` || action.type === `${UNFAVORITE_LIBRARY_VIDEO}_SUCCESS`) {
    const newCategories = nextState.get('data').map(category => {
      const sections = category.get('sections').map(section => {
        const videoIndex = section
          .get('libraryRecords')
          .findIndex(video => video.get('id') === action.json.library_video_id);
        if (videoIndex > -1) {
          return section.updateIn(['libraryRecords', videoIndex], video =>
            video.set('favorited', !video.get('favorited'))
          );
        }
        return section;
      });
      return category.set('sections', sections);
    });
    nextState = nextState.set('data', newCategories);
  }

  return nextState;
};

export default combineReducers({
  categories,
});



// WEBPACK FOOTER //
// ./src/subscription/library/redux/reducers.js